import React from 'react';
import {
  Button, Form, Select,
} from 'antd';
import { useAuth } from '../../contexts/userContext/userContext';
import useTranslation from '../../hooks/translation/useTranslation';
import TinyInput from '../inputs/TinyInput';
import ridePromotionTypeOptions from '../../../utils/constants/ridePromotionTypeOptions';

const LOCALES = ['ka', 'en', 'ru', 'am'];

function RidePromotionForm({
  form, onFinish, isLoading,
}) {
  const { trans, currentLanguage } = useTranslation();
  const {
    ticketBookingOptions: { stations },
  } = useAuth();

  const stationOptions = stations?.map((station) => ({
    label: station?.[`label_${currentLanguage === 'am' ? 'ka' : currentLanguage}`],
    value: station?.value,
  }));

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
    >
      <Form.Item
        label={trans('language')}
        name="locale"
        rules={[{ required: true }]}
      >
        <Select
          options={LOCALES.map((l) => ({ label: l.toUpperCase(), value: l }))}
        />
      </Form.Item>

      <TinyInput
        label={trans('content')}
        name="content"
        form={form}
      />

      <Form.Item
        label={trans('type')}
        name="type"
        rules={[{ required: true }]}
      >
        <Select options={ridePromotionTypeOptions} />
      </Form.Item>

      <Form.Item
        label={trans('departure_station')}
        name="start_station_code"
      >
        <Select
          options={stationOptions}
          showSearch
          allowClear
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
        />
      </Form.Item>

      <Form.Item
        label={trans('arrival_station')}
        name="end_station_code"
      >
        <Select
          options={stationOptions}
          showSearch
          allowClear
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          {trans('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default RidePromotionForm;
